<template>

  <div class="order-summary md:order-summary relative">

    <div class="p-6 md:p-8">

      <!-- Title -->
      <div class="title md:title">
        <slot name="title"></slot>
      </div>

      <vs-divider class="mb-6"></vs-divider>

      <!-- Sub Total -->
      <slot name="body"></slot>

    </div>

    <footer class="order-summary-footer p-4 w-full md:px-8 md:py-4">
      <div class="footer-content md:footer-content">
        <slot name="footer"></slot>
      </div>
    </footer>

  </div>

</template>


<script>

export default {

  name: 'speakol-summary-card',

  data () {
    return {}
  }

}
</script>


<!--suppress CssInvalidAtRule -->
<style lang="scss" scoped>

.order-summary {
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 15px;
  min-height: 380px;
}

.footer-content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #2c2c2c;

  @apply whitespace-no-wrap;
}

.order-summary-footer {
  min-height: 80px;
  background: rgba(0, 146, 215, 0.06);
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
  position: absolute !important;
  bottom: 0;
}

.title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}

@media (min-width: 768px) {
  .md\:title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
  }

  .md\:footer-content {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #2c2c2c;
  }
}

</style>
